import { formatCurrency, formatDate, copyToClipboard } from '@/helpers'
import { MUIColors } from '@/styles/theme'
import { EInvoiceStatus, Invoice, InvoiceStatus } from '@/types'
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  capitalize,
  Chip,
  List,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { InvoiceListItem } from './invoice-list-item'
import { Download, FileCopy } from '@mui/icons-material'

const COLOR_BY_STATUS: Record<InvoiceStatus, MUIColors> = {
  ativa: 'warning',
  paga: 'success',
  cancelada: 'default',
}

export function InvoiceCard({
  value,
  status,
  due_date,
  url,
  barcode,
}: Invoice) {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'))

  return (
    <Accordion
      disableGutters
      sx={{ p: 0, borderRadius: 1, '&::before': { display: 'none' } }}
    >
      <AccordionSummary>
        <Box display="flex" alignItems="center" gap={2} width="100%">
          <Typography variant={isMobile ? 'h6' : 'h5'} flexGrow={1} noWrap>
            {capitalize(formatDate(due_date, 'MMMM/yyyy'))}
          </Typography>

          <Chip
            label={EInvoiceStatus[status]}
            color={COLOR_BY_STATUS[status]}
          />
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        <List sx={{ p: 0 }}>
          <InvoiceListItem label="Valor" value={formatCurrency(value)} />
          <InvoiceListItem label="Vencimento" value={formatDate(due_date)} />
        </List>
      </AccordionDetails>

      <AccordionActions>
        <Stack direction={isMobile ? 'column' : 'row'} width="100%" spacing={1}>
          <Button
            variant="outlined"
            fullWidth
            size="small"
            startIcon={<Download />}
            onClick={() => window.open(url, '_blank', 'noopener, noreferrer')}
          >
            Boleto
          </Button>
          <Button
            variant="outlined"
            fullWidth
            size="small"
            startIcon={<FileCopy />}
            onClick={() => copyToClipboard(barcode)}
          >
            Código de barras
          </Button>
        </Stack>
      </AccordionActions>
    </Accordion>
  )
}
